'use strict';

import { loadCatalogThen } from '@unischool/util/i18n';

loadCatalogThen(() => import('../Auth/AccountLogin/bootstrap'));
